import React, { Component } from 'react';
import CreditorEdit from "../fragments/edit/creditor-edit";
import EmployeeEdit from "../fragments/edit/employee-edit";
class EditPage extends Component {


    render() {
        return (
            <div className="page">
                <CreditorEdit />
                <EmployeeEdit />
            </div>
        );
    }
}

export default EditPage;


// WEBPACK FOOTER //
// ./src/jsx/components/pages/edit-page.jsx